import adminReducer from "@/components/wealth/admin/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const wealthReducer = combineReducers({
  admin: adminReducer,
})

export default wealthReducer
